module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("VUX V2.9.0 released")]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/actionsheet.html"
    }
  }, [_vm._v("Actionsheet")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] add event:on-after-show event:on-after-hide #2465")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/cell.html"
    }
  }, [_vm._v("Cell")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] fix weui-loading style")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/confirm.html"
    }
  }, [_vm._v("Confirm")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] fix inputAttrs issue with no-default-value #2618")]), _vm._v(" "), _c('li', [_vm._v("[fix] fix focus auto-blur issue #2610")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/datetime.html"
    }
  }, [_vm._v("Datetime")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] support order-map to customize column orders #2300")]), _vm._v(" "), _c('li', [_vm._v("[fix] fix mask cause body scroll in iOS #2593")]), _vm._v(" "), _c('li', [_vm._v("[feature] add arg:value for event:on-confirm #2632")]), _vm._v(" "), _c('li', [_vm._v("[fix] fire event:on-confirm after nextTick #2632")]), _vm._v(" "), _c('li', [_vm._v("[feature] support format YYYY-MM-DD A #2627 @jack87918")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/inline-x-switch.html"
    }
  }, [_vm._v("InlineXSwitch")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] new component #2624")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/loading.html"
    }
  }, [_vm._v("Loading")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] add variable loading-z-index #2484")]), _vm._v(" "), _c('li', [_vm._v("[enhance] support using empty text to hide loading text #2566")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/msg.html"
    }
  }, [_vm._v("Msg")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[change] prop:buttons displays as slot:buttons default content")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/picker.html"
    }
  }, [_vm._v("Picker")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] show warning when picker value is not a string #2568")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/popover.html"
    }
  }, [_vm._v("Popover")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] fix position in fixed container #2590")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/popup-picker.html"
    }
  }, [_vm._v("PopupPicker")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] add prop:disabled #2594")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/popup.html"
    }
  }, [_vm._v("Popup")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] support prop:should-rerender-on-show for forcing rerendering #2598")]), _vm._v(" "), _c('li', [_vm._v("[feature] support prop:should-scroll-top-on-show for forcing scrolling top #2598")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/search.html"
    }
  }, [_vm._v("Search")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] add event:on-clear #2251")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/selector.html"
    }
  }, [_vm._v("Selector")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] avoid newer-version-vue select value issue #2633 #2587")]), _vm._v(" "), _c('li', [_vm._v("[enhance] use v-html for title #2615")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/sticky.html"
    }
  }, [_vm._v("Sticky")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] add prop:disabled #2601")]), _vm._v(" "), _c('li', [_vm._v("[enhance] add development tip if scroll-box doesnot exist")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/tab.html"
    }
  }, [_vm._v("Tab")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] support prop:bar-position")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/x-address.html"
    }
  }, [_vm._v("XAddress")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] add prop:disabled #2641")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/x-button.html"
    }
  }, [_vm._v("XButton")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] support plain for warn-button #2478")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/x-circle.html"
    }
  }, [_vm._v("XCircle")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] support gradient #2616 @spencer1994")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/x-dialog.html"
    }
  }, [_vm._v("XDialog")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] support variable dialog-gap-width #2640")]), _vm._v(" "), _c('li', [_vm._v("[enhance] support dialog-width and dialog-max-width variable #2577")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/x-input.html"
    }
  }, [_vm._v("XInput")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] fix wrong valid when value is empty string #2415")]), _vm._v(" "), _c('li', [_vm._v("[fix] fix disabled style in iOS #2458")]), _vm._v(" "), _c('li', [_vm._v("[change] show clear icon only when input gets focus #2567")]), _vm._v(" "), _c('li', [_vm._v("[feature] add event:on-click-clear-icon #2603")]), _vm._v(" "), _c('li', [_vm._v("[enhance] scroll input element into view when getting focus #2604")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-140f2ef2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-140f2ef2"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/v2.9.0-141.vue
// module id = 2046
// module chunks = 229